import Mustache from 'mustache';
import { getTranslation } from './utilities';
import InvoiceClient from './clients/InvoiceClient';

class InvoiceList
{
    constructor()
    {
        this.invoiceListClient = new InvoiceClient();
        this.itemElementTemplate = document.querySelector('#invoiceListItemElementTemplate').innerHTML;
        this.selector = '.js-invoice-list';
        this.invoiceDownloadButtonSelector = '.js-invoice__download-button';

        this.table = undefined;
    }

    init()
    {
        let self = this;

        this.table = $(this.selector).DataTable({
            ajax: {
                url: this.invoiceListClient.uri,
                data: function(data)
                {
                    return {
                        skip: data.start,
                        take: data.length,
                        sort: self.formatOrder(self, data.order)
                    };
                },
                // dataSrc: this.invoiceListClient.dataSrc
                dataSrc: (json) =>
                {
                    let jsonData = json[this.invoiceListClient.dataResponse];
                    return jsonData[this.invoiceListClient.dataSrc];
                }
            },
            dom:'l\
					f\
					r\
					<"invoice-list-table__scroll table--scroll-mobile"t>\
					p\
					i',
            pageLength: 20,
            paging: true,
            info: false,
            serverSide: true,
            processing: true,
            searching: false,
            lengthChange: false,
            language: this.datatableTexts(),
            order: [[0, 'desc']],
            columnDefs: [
                {
                    targets: [0, 1, 2, 3],
                    orderable: false
                },
                {
                    width: '25%',
                    targets: 0,
                    className: 'invoice-list__creation_datetime',
                    render: function(data, type, row)
                    {
                        let invoiceListRow = row.customerPrivateFile;
                        let creationDatetime = new Date(invoiceListRow.creationDatetime.toString());

                        invoiceListRow.fileTypeStandardInvoice = invoiceListRow.fileType === '_invoice_';
                        invoiceListRow.fileTypeFreightInvoice = invoiceListRow.fileType === '_freight_';
                        invoiceListRow.fileTypeCreditnote = invoiceListRow.fileType === '_creditnote_';
                        invoiceListRow.creationDatetime = creationDatetime.getDate() + '.'
							+ ('0' + (creationDatetime.getMonth() + 1)).slice(-2) + '.'
							+ creationDatetime.getFullYear();

                        invoiceListRow.creationDatetimeHours = ('0' + (creationDatetime.getHours() + 1)).slice(-2) + ':'
							+ ('0' + (creationDatetime.getMinutes() + 1)).slice(-2);
                        return Mustache.render(this.itemElementTemplate, {
                            invoiceList: invoiceListRow,
                            invoiceListCreationDate: true
                        });
                    }.bind(this)
                },
                {
                    width: '25%',
                    targets: 1,
                    className: 'invoice-list__erp_file_id text--center',
                    render: function(data, type, row)
                    {
                        let invoiceListRow = row.customerPrivateFile;
                        return Mustache.render(this.itemElementTemplate, {
                            invoiceList: invoiceListRow,
                            invoiceListNumber: true,
                            noDatetime: true
                        });
                    }.bind(this)
                },
                {
                    width: '25%',
                    data: null,
                    targets: 2,
                    className: 'invoice-list__state text--center',
                    render: function(data, type, row)
                    {
                        let invoiceListRow = row.customerPrivateFile;
                        let hadDownloaded = false;
                        let hasNoticed = false;
                        let hasNoDatetime = true;

                        if (invoiceListRow.downloadedDatetime !== 'null')
                        {
                            let downloadedDatetime = new Date(invoiceListRow.downloadedDatetime);
                            invoiceListRow.downloadedDatetime = downloadedDatetime.getDate() + '.'
								+ ('0' + (downloadedDatetime.getMonth() + 1)).slice(-2) + '.'
								+ downloadedDatetime.getFullYear();

                            invoiceListRow.downloadedDatetimeHours = ('0' + (downloadedDatetime.getHours())).slice(-2)
                                + ':' + ('0' + (downloadedDatetime.getMinutes())).slice(-2);

                            hadDownloaded = true;
                            hasNoDatetime = false;
                        }

                        if (invoiceListRow.noticedDatetime !== 'null')
                        {
                            hasNoticed = true;
                            hasNoDatetime = false;
                        }

                        return Mustache.render(this.itemElementTemplate, {
                            invoiceList: invoiceListRow,
                            invoiceListStatus: true,
                            downloaded: hadDownloaded,
                            noticed: hasNoticed,
                            noDatetime: hasNoDatetime
                        });
                    }.bind(this)
                },
                {
                    width: '25%',
                    targets: 3,
                    className: 'invoice-list__download text--center',
                    render: function(data, type, row)
                    {
                        let invoiceListRow = row.customerPrivateFile;
                        invoiceListRow.href = 'assets/private/'
							+ invoiceListRow.mandatorId
							+ '/' + invoiceListRow.customerPrivateFileId
							+ '/' + invoiceListRow.filename;
                        return Mustache.render(this.itemElementTemplate, {
                            invoiceList: invoiceListRow,
                            downloadLink: true
                        });
                    }.bind(this)
                },
            ],
            drawCallback: function()
            {
                $('#invoiceListItemTable thead').show();
                $('#invoiceListItemTable').eq(0).hide();

                this.updateNoticedItems();
                this.initEvents();
            }.bind(this),

            initComplete: function()
            {
                let isEmpty = this.table.data().count() === 0;

                if (!isEmpty)
                {
                    this.createSortSelection(this.table);
                }
            }.bind(this),
            createdRow: function(row, data)
            {
                let $row = $(row);

                $row.attr('data-erp-file-id', data.id);
            }
        });
    }

    initEvents()
    {
        document.querySelectorAll(this.invoiceDownloadButtonSelector).forEach(button =>
        {
            button.addEventListener('click', () =>
            {
                let id = parseInt(button.getAttribute('data-uid'));

                this.invoiceListClient.updateDownloadedItem(id)
                    .catch(error =>
                    {
                        console.error(error);
                    });
            });
        });
    }

    updateNoticedItems()
    {
        let items = this.table.rows().data().toArray();
        let itemIds = items.map(item => item.customerPrivateFile.customerPrivateFileId);

        this.invoiceListClient.updateNoticedItems(itemIds)
            .catch(error =>
            {
                console.error(error);
            });
    }

    createSortSelection(table)
    {
        let filterSection = document.createElement('div');
        let sortSelection = document.createElement('select');

        filterSection.classList.add('invoice-list__sort', 'js-invoice-list__sort', 'select-button-container');

        let { 0: columns } = table.columns();

        for (let i = 0; i < columns.length; i++)
        {
            let optionText = getTranslation('content.invoice.list.header.col.' + i);

            if (optionText)
            {
                let optionDescending = document.createElement('option');
                let optionAscending = document.createElement('option');

                optionDescending.value = columns[i] !== 0 ? columns[i] * -1 : -999;
                optionDescending.text = optionText + ' ' + getTranslation('content.invoice.list.sort.descending');
                sortSelection.appendChild(optionDescending);

                optionAscending.value = columns[i] !== 0 ? columns[i] : 999;
                optionAscending.text = optionText + ' ' + getTranslation('content.invoice.list.sort.ascending');
                sortSelection.appendChild(optionAscending);
            }
        }

        filterSection.append(sortSelection);
        document.querySelector('.js-invoice-list_filter_sorting_section').append(filterSection);

        sortSelection.addEventListener('change', function()
        {
            if (this.value < 0)
            {
                table.order([this.value != -999 ? this.value * -1 : 0, 'desc']).draw();
            }
            else if (this.value > 0)
            {
                table.order([this.value != 999 ? this.value : 0, 'asc']).draw();
            }
            else
            {
                table.order([0, 'asc']).draw();
            }
        });
    }

    datatableTexts()
    {
        return {
            'paginate': {
                'previous': '<i class="fa-regular fa-chevron-left"></i>',
                'next': '<i class="fa-regular fa-chevron-right"></i>',
            },
            'processing': getTranslation('content.invoice.processing'),
            'loadingRecords': getTranslation('content.invoice.loading'),
        };
    }

    formatOrder(self, order)
    {
        $(order).each(function(k)
        {
            order[k].field = self.matchOrderIdWithColumnName(order[k].column);
            order[k].dir = order[k].dir.toUpperCase();
        });

        return order;
    }

    matchOrderIdWithColumnName(orderId)
    {
        switch (orderId)
        {
        case 0:
            return 'creationDatetime';
        case 1:
            return 'erpFileId';
        case 2:
            return 'downloadedTime';
        case 3:
            return 'download';
        default:
            return null;
        }
    }
}

if (document.querySelector('.js-invoice-list') !== null)
{
    (new InvoiceList()).init();
}
